export function parseJwtExpMs(token: string): number | null {
  try {
    const parts = token.split(".");
    if (parts.length !== 3) return null;

    const payload = parts[1]
      .replace(/-/g, "+")
      .replace(/_/g, "/")
      .padEnd(parts[1].length + ((4 - (parts[1].length % 4)) % 4), "=");

    const decoded = JSON.parse(atob(payload)) as { exp?: number };
    if (typeof decoded.exp !== "number") return null;

    return decoded.exp * 1000;
  } catch {
    return null;
  }
}

export function isTokenExpired(token: string, skewSeconds: number = 30): boolean {
  const expMs = parseJwtExpMs(token);
  if (expMs === null) return false;
  return Date.now() >= expMs - skewSeconds * 1000;
}
